import { InstructorAcceptedRequest } from "pages";
import instructorRouteMap from "routeControl/instructorRouteMap";

/**
 * Generates an array of route objects for the admin dashboard.
 * @returns {Array} An array containing the route object for the admin dashboard.
 */
export default function route() {
  return [
    {
      path: instructorRouteMap.USER_ACCEPTED_REQUEST.path, // URL path for the dashboard
      name: "Users", // Display name for the route
      key: instructorRouteMap.USER_ACCEPTED_REQUEST.path, // Unique key for the route
      private: true, // Requires authentication to access
      belongsToSidebar: true, // Appears in the admin sidebar
      icon: instructorRouteMap.USER_ACCEPTED_REQUEST.icon, // Icon associated with the dashboard
      element: <InstructorAcceptedRequest />, // Component to render for this route
    },
  ];
}
